import React, { useState, useEffect } from "react";
import { data } from "./NavBarData";
import NavlinkCard from "./Navbar-Components/NavlinkCard/NavlinkCard";
import "./MobileNavbar.style.css";
import { BsListUl } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import Profile from "./Navbar-Components/Profile/Profile";
import LanguageChange from "./Navbar-Components/LanguageChange/LanguageChange";
import ContactNavbar from "./Navbar-Components/ContactNavbar/ContactNavbar";
import { useNavigate, useLocation, Link } from "react-router-dom";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [backDropShow, setBackDropShow] = useState(false);

  const handleNavCardClick = () => {
    if (show === true) {
      // handle navbar display (in mobile-view)
      setShow(!show);
      // handle backdrop display (in mobile-view)
      setBackDropShow(!backDropShow);
    }
  };
  const handleDisplayNavBar = () => {
    setShow(!show);
  };

  useEffect(() => {
    console.log("show: ", show);
    console.log("backDropShow: ", backDropShow);
    if (backDropShow === true && show === true) {
      // avoid body from scrolling
      document.body.style.overflow = "hidden";
    } else if (backDropShow === false && show === false) {
      // allow body to scroll
      document.body.style.overflow = "";
    }
  }, [show, backDropShow]);

  return (
    <>
      <div
        className="mobile-nav-toggle d-xl-none"
        onClick={handleDisplayNavBar}
      >
        {show ? <AiOutlineClose /> : <BsListUl />}
      </div>
      <header className={show ? "header-section nav-active" : "header-section"}>
        <div className="d-flex flex-column nav-wrapper">
          <Profile />
          <nav className="nav-menu navbar">
            <ul>
              {data.map((item) => {
                return item.name === "shop" ? (
                  location.pathname === "/shop" ? (
                    <a onClick={() => window.scroll(0, 0)} key={item.name}>
                      <div className="nav_link" onClick={handleNavCardClick}>
                        <div className="nav_icon">{item.icon}</div>
                        <div className="nav_name">{`${item.name}`}</div>
                      </div>
                    </a>
                  ) : (
                    <Link to="/shop" key={item.name}>
                      <div className="nav_link" onClick={handleNavCardClick}>
                        <div className="nav_icon">{item.icon}</div>
                        <div className="nav_name">{`${item.name}`}</div>
                      </div>
                    </Link>
                  )
                ) : item.name === "home" ? (
                  location.pathname === "/" ? (
                    <a onClick={() => window.scroll(0, 0)} key={item.name}>
                      <div className="nav_link" onClick={handleNavCardClick}>
                        <div className="nav_icon">{item.icon}</div>
                        <div className="nav_name">{`${item.name}`}</div>
                      </div>
                    </a>
                  ) : (
                    <Link to="/" key={item.name}>
                      <div className="nav_link" onClick={handleNavCardClick}>
                        <div className="nav_icon">{item.icon}</div>
                        <div className="nav_name">{`${item.name}`}</div>
                      </div>
                    </Link>
                  )
                ) : (
                  <NavlinkCard
                    item={item}
                    handleNavCardClick={handleNavCardClick}
                    show={show}
                    key={item.name}
                  />
                );
              })}
            </ul>
          </nav>
          <ContactNavbar />
          <LanguageChange />
        </div>
      </header>
    </>
  );
}

export default Navbar;
